import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-44bfe369"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Такая рекламная кампания уже существует, вы не можете создать ее повторно. Вы можете объединить рекламные кампании или отредактировать и переименовать актуальную рекламную кампанию.", -1))
const _hoisted_2 = { class: "flex buttons" }

import { ref, watch } from "vue";
import Dialog from "primevue/dialog";
import Button from "primevue/button";

import { useRouter } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  __name: 'DuplicatedTraficPlanDialog',
  props: {
    visible: { type: Boolean },
    id: {}
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const router = useRouter();

const props = __props;

const emits = __emit;

const visibleLocal = ref(props.visible);
watch(
  () => props.visible,
  (newValue) => {
    visibleLocal.value = newValue;
  }
);

const goToCampaign = () => {
  emits("close");
  router.push({
    name: "traficPlan",
    params: { id: props.id },
    query: { union: "t" },
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dialog), {
    visible: visibleLocal.value,
    "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((visibleLocal).value = $event)),
    onHide: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('close'))),
    modal: "",
    header: "Имя кампании существует в системе",
    style: { width: '30rem' }
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(Button), {
          type: "button",
          label: "Объединить РК",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (goToCampaign()))
        }),
        _createVNode(_unref(Button), {
          type: "button",
          label: "Переименовать",
          severity: "secondary",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
        })
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})